import { render } from "./RxHistory.vue?vue&type=template&id=09091037&scoped=true"
import script from "./RxHistory.vue?vue&type=script&lang=js"
export * from "./RxHistory.vue?vue&type=script&lang=js"

import "./RxHistory.vue?vue&type=style&index=0&id=09091037&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-09091037"]])

export default __exports__